import React from "react";
import Title from "components/title";
import Verify from "components/verify";
import "./index.less";
import { TextareaItem, Icon, Toast, Picker } from "antd-mobile";
import { createForm } from "rc-form";
import { connect } from "react-redux";
import Actor from "tools/actor"; //全局接口方法
import Position from "assets/images/local.png";
import Search from "assets/images/w_search.png";
import intl from "react-intl-universal";
import {
  setName,
  setPhone,
  setProblems,
  getBannerImg,
  setTime,
  setDeliver,
  setShop,
  setThpro,
  setProList,
  setcityshow,
  setlatlong,
  setCountryActive, chooseModel,setidwuliulist,setonSiteList,setonSiteCity
} from "tools/store";
import WebApi from "tools/webApi";
import Img1 from "assets/images/img1.png";
import Gtinit from 'tools/gt'
import { countryList } from "tools/couchangetext";
import APPJS from "tools/cc";
import md5 from "js-md5";

// pc 端
import PCModel from "../pc/model"
import PCFault from "../pc/fault"


//选择器
const CustomChildren = (props: any) => {
  return (
    <div className="tesTop" onClick={props.onClick}>
      <div className="test">
        <div
          style={{
            flex: 1,
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
          }}
        >
          {props.children}
        </div>
        <div style={{ textAlign: "right", color: "#666", marginRight: 15 }}>
          {props.extra}
        </div>
      </div>
    </div>
  );
};
//全局状态
const mapStateToProps = (state: any) => {
  return {
    model: state.defaultState.model,
    problems: state.defaultState.problems,
    imgUrl: state.defaultState.imgUrl,
    infoName: state.defaultState.infoName, //客户名字
    infoPhone: state.defaultState.infoPhone, //客户手机号
    shopMessage: state.defaultState.shopMessage, //店铺信息
    time: state.defaultState.time, //店铺信息
    countryActiveMcc: state.defaultState.countryActiveMcc,
    countryActive: state.defaultState.countryActive,
    storeState: state.defaultState,
    onSiteService: state.defaultState.onSiteService,
    onSiteList: state.defaultState.onSiteList,
    onSiteCity: state.defaultState.onSiteCity,
    // 寄修业务
    isDeliveryArea: state.defaultState.isDeliveryArea,
    isDeliverySite: state.defaultState.isDeliverySite,
    deliveryAddrees1: state.defaultState.deliveryAddrees1,
    deliveryAddcode1: state.defaultState.deliveryAddcode1,
    needDeliveryAddrees2: state.defaultState.needDeliveryAddrees2,
    deliveryAddrees2: state.defaultState.deliveryAddrees2,
    deliveryAddcode2: state.defaultState.deliveryAddcode2,
    deliveryFaulttype: state.defaultState.deliveryFaulttype,
    proList: state.defaultState.proList,
    cityname: state.defaultState.cityname,
    latlong: state.defaultState.latlong,
  };
};
const mapDispatchToProps = (dispatch: any) => ({
  setProblems: (v: any) => {
    dispatch(setProblems(v));
  },
  getImg: (v: any) => {
    dispatch(getBannerImg(v));
  },
  setName: (v: any) => {
    dispatch(setName(v));
  },
  setPhone: (v: any) => {
    dispatch(setPhone(v));
  },
  setTime: (v: any) => {
    dispatch(setTime(v));
  },
  setDeliver: (v: any) => {
    dispatch(setDeliver(v));
  },
  setShop: (v: any) => {
    dispatch(setShop(v));
  },
  setThpro: (v: any) => {
    dispatch(setThpro(v));
  },
  setProList: (v: any) => {
    dispatch(setProList(v));
  },
  setcityshow: (v: any) => {
    dispatch(setcityshow(v));
  },
  setlatlong: (v: any) => {
    dispatch(setlatlong(v));
  },
  setidwuliulist: (v: any) => {
    dispatch(setidwuliulist(v));
  },
  setonSiteList: (v: any) => {
    dispatch(setonSiteList(v));
  },
  setonSiteCity: (v: any) => {
    dispatch(setonSiteCity(v));
  },
  clear: () => {
    dispatch(
      setCountryActive({
        name: "",
        mcc: "",
      })
    );
    dispatch(
      chooseModel({
        leftName: "", //品牌
        leftCode: "",
        rightName: "", //机型
        rightCode: "",
      })
    );
    dispatch(
      setShop({
        storeName: "",
        storeCode: "",
        storeAddr: "",
      })
    );
    dispatch(setTime([]));
    dispatch(setName(""));
    dispatch(setPhone(""));
    dispatch(setProblems(""));
  },
});
@(connect(mapStateToProps, mapDispatchToProps) as any)
class Subscribe extends React.Component<any, any> {
  constructor(props: any) {
    super(props);
    this.state = {
      isSelect: false, //质量蒙层开关
      id: "",
      time: [], //["20220-04-25", "09:00-12:00"]
      shopName: "",
      shopAddress: "",
      isAr: false, //是否为阿拉伯语
      isthpro: false,
      showEnter: false,//印尼查订单弹窗
      detailCode: '',//印尼查单号
      appVersion: "",
      afid: "",
      deliover40: false,//超过40公里,
      token: '',
      tjstatus: 0,//0 非提交状态  1 普通提交  2寄修提交

      // pc端
      pcModelshow: false,
      pcFaultshow: false,
      // 中高端用户
      isgooduser: false,
      // ssa项目不需要price查询
      SSA:false,
      // H5查询订单列表使用前的vcode
      vcodeuuid:"",
      vcodeimg:"",
      vcode:"",
      isOnSite:false,//上门服务列表
    };
  }
  //去选择机型
  toModel = () => {
    let par: string = window.location.href.split("?")[1]
      ? "?" + window.location.href.split("?")[1]
      : "";
    this.props.history.push("/model" + par);
  };
  toModelpc = (event: any) => {
    event.stopPropagation();
    this.state.pcModelshow ?
      this.setState({
        pcModelshow: false,
      }) : this.setState({
        pcModelshow: true,
      })
  };
  //去查看价格
  toPrice = () => {
    if (!(this.props.model.rightCode + "")) {
      //先选择手机
      Toast.info(intl.get("error.name6"), 3);
    } else {
      // 谷歌埋点---PV-price
      gtag('event', 'Reservation_PV-price' + Gtinit());


      let par: string = window.location.href.split("?")[1]
        ? "?" + window.location.href.split("?")[1]
        : "";
      this.props.history.push("/modelPrice" + par);
    }
  };
  //绑定文本输入框
  handleTextareaChange = (e: String) => {
    if (//2. 清洗券
      this._parseQueryString("?" + window.location.href.split("?")[1])
        ?.comefrom === "orderlotteryfree" && ((this._parseQueryString("?" + window.location.href.split("?")[1])
          ?.source || "").indexOf("LUCK_DRAW") < 0)
    ) {
      // this.props.setProblems(intl.get("name58") || "Free Cleaning/Free Software Upgrade");
    } else {
      this.props.setProblems(e);
    }
  };
  //生命周期
  componentDidMount() {
    // 中高端用户
    if (this._parseQueryString("?" + window.location.href.split("?")[1])
      ?.gooduser === "1") {
      this.setState({ isgooduser: true });
      if(!this.props.problems){
        this.props.setProblems('Free Cleaning');
      }
    }
    // ssa项目不需要price查询
    if (this._parseQueryString("?" + window.location.href.split("?")[1])
      ?.activity === "SSA") {
      this.setState({ SSA: true });
    }else{
      this.setState({ SSA: false });
    }

    if (//2. 清洗券
      this._parseQueryString("?" + window.location.href.split("?")[1])
        ?.comefrom === "orderlotteryfree" && ((this._parseQueryString("?" + window.location.href.split("?")[1])
          ?.source || "").indexOf("LUCK_DRAW") < 0)
    ) {
      this.props.setProblems(intl.get("name58") || "Free Cleaning/Free Software Upgrade");
    }
    console.log(this.props.time)
    const lang = intl.getInitOptions().currentLocale;

    let a = this._parseQueryString("?" + window.location.href.split("?")[1])
      .shopId;

    if (a) console.log("店铺id：" + a);//假如写死店铺
    this.setState({
      id: a,
      isAr: lang === "ar" ? true : false,
    });

    if (!this.props.imgUrl) {
      //全局请求图片
      Actor.getBannerImg();
    }
    //时间列表
    if (!!this.props.shopMessage.storeCode) {
      this.getTimes();
    } else if (a && this.props.model.leftName && !this.props.time[0]) {// 匹配店铺
      this.getTimes(a);
    }
    let _this = this;
    APPJS.userinfo().then((res: any) => {
      _this.setState({ appVersion: res.appVersion, afid: res.afid, token: res.token })
    })
  }
  // 选择寄售服务
  onSite = () => {
    let _this = this;
    if (this.props.countryActiveMcc === "404000") {
      this.props.setDeliver({ type: 2, data: 1 });
      this.props.setDeliver({ type: 8, data: [] });
    } else if (this.props.countryActiveMcc === "520") {
      this.props.setDeliver({ type: 2, data: 1 });
      this.props.setDeliver({ type: 8, data: [] });
      // 处理泰国省份列表弹窗显示
      this.prolists();
    } else if (this.props.countryActiveMcc === "515") {
      this.props.setDeliver({ type: 2, data: 1 });
      this.props.setDeliver({ type: 8, data: [] });
      // 处理菲律宾省份列表弹窗显示
      this.prolists();
    } else {
      this.props.setTime([]);
      this.props.setThpro('');//清除泰国省份
      // 2023-02  印尼城市处理，城市获取店铺之后提交店铺
      let shopdata: any = {
        "country": this.props.countryActive.name,
        "province": this.props.cityname.cityEng,
        "longitude": '',
        "latitude": ''
      }
      Toast.loading("Loading...", 10000, () => { });
      // 官网寄修快处理匹配店铺
      if (this._parseQueryString("?" + window.location.href.split("?")[1])
        ?.needDelivery === "1") {
        Toast.hide();
        shopdata.latitude = this._parseQueryString("?" + window.location.href.split("?")[1])
          ?.lat;
        shopdata.longitude = this._parseQueryString("?" + window.location.href.split("?")[1])
          ?.long;
        // 请求店铺
        WebApi.deliveryShop(shopdata).then((resShop: any) => {
          if (resShop && +resShop.code === 200) {
            let resData: any = resShop.data.storeInfoMode[0];
            console.log(resData)
            if (+resData.distance < 40) {
              _this.props.setDeliver({ type: 2, data: 1 });
              _this.props.setDeliver({ type: 8, data: [] });
              _this.props.setShop({
                storeName: resData.storeName,
                storeCode: resData.storeCode,
                storeAddr: "Carlcare Repairs Center",
              })
              _this.props.setlatlong([shopdata.latitude, shopdata.longitude]);//设置经纬度
              _this.getTimes(resData.storeCode, 1);
            } else {
              _this.setState({ deliover40: true })
            }
          }
        })
      } else if (!(this.state.appVersion.slice(1) >= "6.0.4")) {
        // 定位兼容app处理
        navigator.geolocation.getCurrentPosition(
          function (position) {
            Toast.hide();
            shopdata.latitude = position.coords.latitude; //获取纬度"-6.1753942" ||
            shopdata.longitude = position.coords.longitude; //获取经度"106.827183" || 
            // 请求店铺
            WebApi.deliveryShop(shopdata).then((resShop: any) => {
              if (resShop && +resShop.code === 200) {
                let resData: any = resShop.data.storeInfoMode[0];
                console.log(resData)
                if (+resData.distance < 40) {
                  _this.props.setDeliver({ type: 2, data: 1 });
                  _this.props.setDeliver({ type: 8, data: [] });
                  _this.props.setShop({
                    storeName: resData.storeName,
                    storeCode: resData.storeCode,
                    storeAddr: "Carlcare Repairs Center",
                  })
                  _this.props.setlatlong([shopdata.latitude, shopdata.longitude]);//设置经纬度
                  _this.getTimes(resData.storeCode, 1);
                  // let a = (+new Date()) + 1000 * 3600 * 24 * 7;
                  // let b = (new Date(a));
                  // let y = b.getFullYear();
                  // let m = b.getMonth() + 1;
                  // let d = b.getDate();
                  // let datse = y + "-" + (m < 10 ? "0" + m : m) + "-" + (d < 10 ? "0" + d : d);
                  // _this.props.setTime([datse, '14:00-15:00'])
                } else {
                  _this.setState({ deliover40: true })
                }
              }
            })
          },
          function () {
            Toast.hide();
            if (_this._parseQueryString("?" + window.location.href.split("?")[1])
              ?.needDelivery === "2") {
              shopdata.latitude = _this._parseQueryString("?" + window.location.href.split("?")[1])
                ?.lat;
              shopdata.longitude = _this._parseQueryString("?" + window.location.href.split("?")[1])
                ?.long;
              // 请求店铺
              WebApi.deliveryShop(shopdata).then((resShop: any) => {
                if (resShop && +resShop.code === 200) {
                  let resData: any = resShop.data.storeInfoMode[0];
                  console.log(resData)
                  if (+resData.distance < 40) {
                    _this.props.setDeliver({ type: 2, data: 1 });
                    _this.props.setDeliver({ type: 8, data: [] });
                    _this.props.setShop({
                      storeName: resData.storeName,
                      storeCode: resData.storeCode,
                      storeAddr: "Carlcare Repairs Center",
                    })
                    _this.props.setlatlong([shopdata.latitude, shopdata.longitude]);//设置经纬度
                    _this.getTimes(resData.storeCode, 1);
                  } else {
                    _this.setState({ deliover40: true })
                  }
                }
              })
            } else {
              Toast.info(intl.get("add2.name22") || "gagal mendapatkan lokasi coba lagi pls", 3);
            }

          },
          {
            enableHighAccuracy: true,
            timeout: 5000,
            maximumAge: 0,
          }
        );
      } else {
        APPJS.requestLocation().then((res: any) => {
          if (res.has) {
            shopdata.latitude = res.latitude;//"-6.1753942"; //获取纬度
            shopdata.longitude = res.longitude;//"106.827183"; //获取经度
            // 请求店铺
            WebApi.deliveryShop(shopdata).then((resShop: any) => {
              if (resShop && +resShop.code === 200) {
                let resData: any = resShop.data.storeInfoMode[0];
                console.log(resData)
                if (+resData.distance < 40) {
                  _this.props.setDeliver({ type: 2, data: 1 });
                  _this.props.setDeliver({ type: 8, data: [] });
                  _this.props.setShop({
                    storeName: resData.storeName,
                    storeCode: resData.storeCode,
                    storeAddr: "Carlcare Repairs Center",
                  })
                  _this.props.setlatlong([shopdata.latitude, shopdata.longitude]);//设置经纬度
                  _this.getTimes(resData.storeCode, 1);
                  // let a = (+new Date()) + 1000 * 3600 * 24 * 7;
                  // let b = (new Date(a));
                  // let y = b.getFullYear();
                  // let m = b.getMonth() + 1;
                  // let d = b.getDate();
                  // let datse = y + "-" + (m < 10 ? "0" + m : m) + "-" + (d < 10 ? "0" + d : d);
                  // _this.props.setTime([datse, '14:00-15:00'])
                } else {
                  _this.setState({ deliover40: true })
                }
              }
            })
          } else {
            Toast.info(intl.get("add2.name22") || "gagal mendapatkan lokasi coba lagi pls", 3);
          }
        })
      }  
    }
  };
  // 选择上门服务
  handleonSiteService=()=>{
    let _this = this;
    if (!(this.state.appVersion.slice(1) >= "6.0.4")) {
      // 定位兼容app处理
      navigator.geolocation.getCurrentPosition(
        function (position) {
          _this.setState({isOnSite:true})
          _this.props.setlatlong([position.coords.latitude, position.coords.longitude]);
        },
        function () {
          Toast.info(intl.get("onSiteService.name3"), 3);
        },
        {enableHighAccuracy: true,timeout: 5000,maximumAge: 0,}
      );
    } else {
      APPJS.requestLocation().then((res: any) => {
        if (res.has) {
          _this.setState({isOnSite:true})
          _this.props.setlatlong([res.latitude, res.longitude]);
        } else {
          Toast.info(intl.get("onSiteService.name3"), 3);
        }
      })
    }  
  }
  onSiteService=(v:any)=>{
    let _this = this;
    this.props.setTime([]);
    this.props.setThpro('');//清除泰国省份
    this.props.setDeliver({ type: 2, data: 2 });//上门服务
    // 上门数据
    let shopdata: any = {
      "mcc": this.props.countryActive.mcc,
      "serviceLocation": v.serviceLocation,
      "longitude": this.props.latlong[1],
      "latitude": this.props.latlong[0],
      "type":1,//1一个门店，2，所有门店
    }
    // 请求店铺
    WebApi.getonsiteShopList(shopdata).then((resShop: any) => {
      if (resShop && +resShop.code === 200) {
        let resData: any = resShop.data[0];
        if (resData) {
          _this.props.setShop({
            storeName: resData.storeName,
            storeCode: resData.storeCode,
            storeAddr: resData.storeAddr,
          })
          _this.getTimes(resData.storeCode);
        }
      }
    })
  }
  inStore = () => {
    this.props.setThpro('');//泰国省份
    this.props.setDeliver({ type: 2, data: 0 });
    this.props.setTime([])
    this.props.setShop({
      storeName: "",
      storeCode: "",
      storeAddr: "",
    })
  };
  
  // 省份列表处理
  prolists = async () => {
    let res: any = await WebApi.deliveryProvince({ country: this.props.storeState.countryActive.name })
    if (res && +res.code === 200) {
      this.props.setProList(res.data);
      this.setState({ isthpro: true });
    }
  }

  //获取时间
  getTimes = async (stcode: string = '', delivery: number = 0) => {
    let _this = this;
    let res: any = await WebApi.getTimes({
      storeCode: stcode || this.props.shopMessage.storeCode,
      isIndonesiaDelivery: delivery || (this.props.isDeliverySite===1 && this.props.countryActiveMcc === "510" ? 1 : 0)
    });
    if (res && +res.code === 200) {
      let data3 = res.data;
      let data4: any = [];
      data3.forEach((v: any) => {
        let asd = {
          label: v.date,
          value: v.date,
          children: _this.timeLi(v.list),
        };
        data4.push(asd);
      });
      this.setState({
        timeList: data4,
      });
      if (!this.props.shopMessage.storeCode && data3[0].storeInfo.storeName) {
        this.props.setShop({
          storeName: data3[0].storeInfo.storeName,
          storeCode: stcode,
          storeAddr: data3[0].storeInfo.storeAddr,
        });
      }
      //时间选择器主动弹出
      if (this.props.time.length < 1) {
        let aa: any = document.getElementsByClassName("tesTop")[0];
        aa.click();
      }
    }
  };

  //时间格式化
  timeLi = (v: any) => {
    let d: any = [];
    v.forEach((element: any) => {
      d.push({
        label: element.timeRegion,
        value: element.timeRegion,
        active: element.active,
      });
    });
    return d;
  };
  //去店铺列表
  toShops = () => {
    if (!(this.props.model.rightCode + "")) {
      //先选择手机
      Toast.info(intl.get("error.name6"), 3);
    } else {
      let par: string = window.location.href.split("?")[1]
        ? "?" + window.location.href.split("?")[1]
        : "";

      // 判断去泰国专属页面还是其他国家店铺页面 
      if ((this.props.countryActiveMcc === '520' ||this.props.countryActiveMcc === '515' || this.props.countryActiveMcc === '404000') && this.props.isDeliverySite===1) {
        this.props.history.push("/deshops" + par);
      } else {
        this.props.history.push("/shops" + par);
      }
    }
  };
  //去寄售维修类型
  toFaultType = () => {
    let par: string = window.location.href.split("?")[1]
      ? "?" + window.location.href.split("?")[1]
      : "";
    this.props.history.push("/faultType" + par);
  };
  showFaultType = () => {
    this.setState({
      pcFaultshow: true
    });
  };
  //url解析入参
  _parseQueryString = (queryString: any) => {
    if (queryString && queryString.startsWith("?")) {
      const result: any = {};
      queryString
        .slice(1)
        .split("&")
        .forEach((item: any) => {
          const keyValueList = item.split("=");
          result[keyValueList[0]] = decodeURIComponent(keyValueList[1]);
          if (keyValueList[0] === "actionAuthCode") {
            result[keyValueList[0]] = decodeURIComponent(item.split("actionAuthCode=")[1])
          }
        });
      return result;
    } else {
      return {};
    }
  };
  // 查询印尼订单
  checkDetail = async () => {
    if (!this.state.detailCode.trim()) {
      return
    }
    if(this.state.vcode.trim().length!==5){
      return
    }

    let a: any = this.state.detailCode;
    if (+a == a) {
      if (a.startsWith("62")) {//需要改成62
        a = "+" + a
      } else if (a.startsWith("+62")) {

      } else {
        a = "+62" + a
      }
    }
    let parm = {
      phoneOrOrderNum: a,
      code:this.state.vcode.trim(),
      uuid:this.state.vcodeuuid,
    }
    console.log(parm);
    let res: any = await WebApi.wuliulist(parm);
    if (res && res.code === 200) {
      if (res.data?.length > 0) {
        this.props.setidwuliulist(res.data)
        
        setTimeout(() => {
          let par: string = window.location.href.split("?")[1]
          ? "?" + window.location.href.split("?")[1]
          : "";
          // this.props.history.push('/checkDetails/' + this.state.detailCode)
          this.props.history.push('/checkDetails' +par)
        }, 10);
      } else {
        Toast.info(intl.get("shopDetails.name1"));
      }
    } else {
      Toast.fail(" ")
    }
  }

  //输入信息
  phone = (e: any) => {
    this.props.setPhone(e.target.value);
  };
  name = (e: any) => {
    this.props.setName(e.target.value);
  };
  canBtn=()=>{
    if(this.props.problems.trim() &&this.props.time.length > 1 &&this.props.infoPhone &&this.props.infoName.trim()){
      if(this.props.isDeliverySite===2&&!(this.props.deliveryAddrees1.trim())){
        return false;
      }else{
        return true; 
      }
    }else{
      return false;
    }
  }
  //提交信息
  onBtn = () => {
    if (this.canBtn()) {
      // 新增号码长度校验
      if (this.props.countryActiveMcc && countryList[this.props.countryActiveMcc]) {
        const area: any = countryList[this.props.countryActiveMcc].telength;
        console.log(area)
        if (area.indexOf("" + this.props.infoPhone.length) < 0) {
          Toast.info(intl.get('add1.name3').replace('%1$s', area[1] ? area[0] + "/" + area[1] : area[0]))
          return;
        }
      }
      // 可以执行寄修提交的事情
      this.setState({ tjstatus: 1 })
      // this.pttj();
    }
  };

  // 普通维修提交
  pttj = async () => {
    // 谷歌埋点---打开预约页面并点击了submit
    gtag('event', 'Reservation_Submit' + Gtinit());


    // 来自与makemoney邀请
    let makemoney = this._parseQueryString("?" + window.location.href.split("?")[1]).makemoney || '';
    // 来自bnfarm
    let fmakemoney = this._parseQueryString("?" + window.location.href.split("?")[1]).fmakemoney || '';
    // 活动邀请
    let ccactivity = this._parseQueryString("?" + window.location.href.split("?")[1]).ccactivity || '';
    // 用户afid
    let userselfid = this._parseQueryString("?" + window.location.href.split("?")[1]).userselfid || this.state.afid || "";

    let parms: any = {
      appointDate: this.props.time[0],
      brand: this.props.model.leftName,
      faultDesc: this.props.problems.trim(),
      model: this.props.model.rightName,
      source:
        this._parseQueryString("?" + window.location.href.split("?")[1])
          .source || "H5",
      actionAuthCode:
        this._parseQueryString("?" + window.location.href.split("?")[1])
          .actionAuthCode || "",
      storeCode: this.props.shopMessage.storeCode,
      timeRegion: this.props.time[1],
      userPhone: this.props.infoPhone,
      userName: this.props.infoName.trim(),
      "exclusiveOrder": false,
      "exclusiveAfid": "",
      afid: userselfid,
      repairMethod: 'in-store repair',
    };
    if (makemoney) {
      parms.exclusiveOrder = true;
      parms.exclusiveAfid = makemoney;
    }
    if (fmakemoney) {
      parms.exclusiveOrder = true;
      parms.exclusiveAfid = fmakemoney;
      parms.makeMoney = false;
      parms.userShareActivity = "CC-MANOR-BD"
    }
    // 上门维修
    if(this.props.isDeliverySite===2){
      parms.repairMethod = "on-site service";
      parms.homeMaintenanceAddress=this.props.deliveryAddrees1;
    }
    // 需要getkey预处理
    let firstkey: any = await WebApi.getkey({})
    let keydata: any = firstkey.data;
    let keyhead: any = firstkey.headers;
    let keytoken: string = md5(keydata.data.key + keyhead.token + keydata.data.secret)
    let keytimestamp = Math.round(((+keydata.timestamp) + (+keyhead.timestamp)) * 0.618);
    let ooodata: any = keytoken + parms.appointDate + keytimestamp +
      keytoken + parms.brand + keytimestamp +
      keytoken + parms.model + keytimestamp +
      keytoken + parms.faultDesc + keytimestamp +
      keytoken + parms.storeCode + keytimestamp +
      keytoken + parms.timeRegion + keytimestamp +
      keytoken + parms.userPhone + keytimestamp +
      keytoken + parms.userName + keytimestamp;
    let keysign: any = md5(ooodata)
    let otherkeydata: any = {
      key: keydata.data.key,
      secret: keydata.data.secret,
      token: keyhead.token,
      timestamp: keyhead.timestamp,
      sign: keysign,
    }





    let res: any;
    if (//2. 清洗券
      this._parseQueryString("?" + window.location.href.split("?")[1])
        ?.comefrom === "orderlotteryfree"
    ) {
      // 埋点----在跳转到线上预约页面后填写预约信息之后，点击提交按钮
      gtag("event", "LuckyDraw202308_ordersubmit");
      //  清洗单，免费单接口
      let activity: string = this._parseQueryString("?" + window.location.href.split("?")[1])
        ?.source;
      let freemcc: any = 0;
      if (activity.indexOf("LUCK_DRAW") < 0) {
        activity = '';
      } else {
        freemcc = this.props.countryActiveMcc;
      }
      // sunnbird 下清洗单submit
      if (this._parseQueryString("?" + window.location.href.split("?")[1])
        ?.actionAuthCode) {
        res = await WebApi.submit(parms, otherkeydata, this.state.token)
      } else {
        res = await WebApi.freeSubmit(parms, this.state.token, activity, freemcc)
      }

    } else {
      res = await WebApi.submit(parms, otherkeydata, this.state.token)
    }
    if (res && +res.code === 200) {
      // facebook监测
      fbq('track', 'SubmitApplication');
      twq('event', 'tw-o6z63-obxfj', {
        conversion_id: "SubmitApplication" // use this to pass a unique ID for the conversion event for deduplication (e.g. order id '1a2b3c')
      });

      this.props.clear();

      // 谷歌埋点---下单成功
      gtag('event', 'Reservation_ordersuccess' + Gtinit());
      if (//2. 清洗券
        this._parseQueryString("?" + window.location.href.split("?")[1])
          ?.comefrom === "orderlotteryfree"
      ) {
        this.props.history.replace("/reserSuccess?orderNum=" + res.data.orderNum);
        // let activity: string = this._parseQueryString("?" + window.location.href.split("?")[1])
        //   ?.source;
        // if (activity.indexOf("LUCK_DRAW") < 0) {
        //   activity = '';
        // }
        // if (activity) {
        //   this.props.history.replace("/reserSuccess?orderNum=" + res.data.orderNum + "&activity=" + activity);
        // } else {
        //   this.props.history.replace("/reserSuccess?orderNum=" + res.data.orderNum);
        // }
      } else if (makemoney) {
        this.props.history.push("/reserSuccess?makemoney=1&orderNum=" + res.data.orderNum);
      } else if (ccactivity === 'moneytree') {
        this.props.history.push("/reserSuccess?ccactivity=moneytree&orderNum=" + res.data.orderNum);
      } else if (this._parseQueryString("?" + window.location.href.split("?")[1]).source === 'H5_worldcup') {
        this.props.history.push("/reserSuccess?ccactivity=H5_worldcup&orderNum=" + res.data.orderNum);
      } else {
        this.props.history.push("/reserSuccess?orderNum=" + res.data.orderNum);
      }
    } else {
      Toast.fail(intl.get("error.name5"), 2);
    }
  }

  //寄售提交信息
  canDeliveryBtn = () => {
    // console.log(this.props.storeState);
    const { deliveryFaulttype, problems, needDeliveryAddrees2, deliveryAddrees1, deliveryAddcode1,
      deliveryAddrees2, deliveryAddcode2, time, infoPhone, infoName, model } = this.props.storeState;
    // 提交场景分析-----problem是否需要些
    if (deliveryFaulttype.length > 0 && deliveryFaulttype[0] === -1 && (!problems.trim())) {
      return false;
    }
    // 判断是否添加地址2
    if (needDeliveryAddrees2 && ((!deliveryAddrees2.trim())
      // || (!deliveryAddcode2.trim())
    )) {
      return false;
    }
    // 印度必须有邮编
    if (this.props.countryActiveMcc === '404000') {
      if (needDeliveryAddrees2 && ((!deliveryAddrees2.trim()) || (!deliveryAddcode2.trim()))) { return false; }
      if (!(deliveryAddcode1.trim())) { return false; }
    }


    if (time.length > 1 && infoPhone &&
      infoName.trim() && model.rightName &&
      deliveryAddrees1.trim()
      // && deliveryAddcode1.trim()
      && deliveryFaulttype.length > 0) {
      return true;
    } else {
      return false;
    }
  }

  onDeliveryBtn = () => {
    if (this.canDeliveryBtn()) {
      // 新增号码长度校验
      if (this.props.countryActiveMcc && countryList[this.props.countryActiveMcc]) {
        const area: any = countryList[this.props.countryActiveMcc].telength;
        if (area.indexOf("" + this.props.infoPhone.length) < 0) {
          Toast.info(intl.get('add1.name3').replace('%1$s', area[1] ? area[0] + "/" + area[1] : area[0]))
          return;
        }
      }
      // 可以执行寄修提交的事情
      this.setState({ tjstatus: 2 })
      // this.jxtj();
    }
  };

  // 寄修提交
  jxtj = async () => {
    // 谷歌埋点---打开预约页面并点击了submit
    gtag('event', 'Reservation_Submit' + Gtinit());


    // 来自与makemoney邀请
    let makemoney = this._parseQueryString("?" + window.location.href.split("?")[1]).makemoney || '';
    // 活动邀请
    let ccactivity = this._parseQueryString("?" + window.location.href.split("?")[1]).ccactivity || '';
    // 用户afid
    let userselfid = this._parseQueryString("?" + window.location.href.split("?")[1]).userselfid || this.state.afid||"";

    let parms = {
      appointDate: this.props.time[0],
      brand: this.props.model.leftName,
      faultDesc: this.props.deliveryFaulttype[0] === -1 ? this.props.problems.trim() : (this.props.deliveryFaulttype[2].title || this.props.deliveryFaulttype[2]),
      model: this.props.model.rightName,
      source:
        this._parseQueryString("?" + window.location.href.split("?")[1])
          .source || "H5",
      actionAuthCode:
        this._parseQueryString("?" + window.location.href.split("?")[1])
          .actionAuthCode || "",
      storeCode: this.props.shopMessage.storeCode,
      timeRegion: this.props.time[1],
      userPhone: (("+" + countryList[this.props.countryActiveMcc].areaTel) || "+62") + this.props.infoPhone,
      userName: this.props.infoName.trim(),
      "exclusiveOrder": false,
      "exclusiveAfid": "",
      afid: userselfid,
      repairMethod: 'delivery service',
      homeMaintenanceAddress: this.props.deliveryAddrees1.trim(),
      sendingPostalCode: this.props.deliveryAddcode1.trim(),
      returningPostalCode: this.props.needDeliveryAddrees2 ? this.props.deliveryAddcode2.trim() : "",
      returningAddress: this.props.needDeliveryAddrees2 ? this.props.deliveryAddrees2.trim() : '',
      latitude: this.props.latlong[0],//-6.1754007
      longitude: this.props.latlong[1],//106.8271584380669,
    };
    if (makemoney) {
      parms.exclusiveOrder = true;
      parms.exclusiveAfid = makemoney;
    }
    if (this.props.countryActiveMcc !== '510') {
      // 需要getkey预处理
      let firstkey: any = await WebApi.getkey({})
      let keydata: any = firstkey.data;
      let keyhead: any = firstkey.headers;
      let keytoken: string = md5(keydata.data.key + keyhead.token + keydata.data.secret)
      let keytimestamp = Math.round(((+keydata.timestamp) + (+keyhead.timestamp)) * 0.618);
      let ooodata: any = keytoken + parms.appointDate + keytimestamp +
        keytoken + parms.brand + keytimestamp +
        keytoken + parms.model + keytimestamp +
        keytoken + parms.faultDesc + keytimestamp +
        keytoken + parms.storeCode + keytimestamp +
        keytoken + parms.timeRegion + keytimestamp +
        keytoken + parms.userPhone + keytimestamp +
        keytoken + parms.userName + keytimestamp;
      let keysign: any = md5(ooodata)
      let otherkeydata: any = {
        key: keydata.data.key,
        secret: keydata.data.secret,
        token: keyhead.token,
        timestamp: keyhead.timestamp,
        sign: keysign,
      }



      let res: any = await WebApi.submit(parms, otherkeydata, this.state.token);
      if (res && +res.code === 200) {
        // facebook监测
        fbq('track', 'SubmitApplication');
        twq('event', 'tw-o6z63-obxfj', {
          conversion_id: "SubmitApplication" // use this to pass a unique ID for the conversion event for deduplication (e.g. order id '1a2b3c')
        });

        this.props.clear();

        // 谷歌埋点---下单成功
        gtag('event', 'Reservation_ordersuccess' + Gtinit());

        if (makemoney) {
          this.props.history.push("/reserSuccess?makemoney=1&orderNum=" + res.data.orderNum);
        } else if (ccactivity === 'moneytree') {
          this.props.history.push("/reserSuccess?ccactivity=moneytree&orderNum=" + res.data.orderNum);
        } else {
          this.props.history.push("/reserSuccess?orderNum=" + res.data.orderNum);
        }
      } else {
        Toast.fail(intl.get("error.name5"), 2);
      }
    } else {
      // 需要getkey预处理
      let firstkey: any = await WebApi.getkey({})
      let keydata: any = firstkey.data;
      let keyhead: any = firstkey.headers;
      let keytoken: string = md5(keydata.data.key + keyhead.token + keydata.data.secret)
      let keytimestamp = Math.round(((+keydata.timestamp) + (+keyhead.timestamp)) * 0.618);
      let ooodata: any = keytoken + parms.appointDate + keytimestamp +
        keytoken + parms.brand + keytimestamp +
        keytoken + parms.model + keytimestamp +
        keytoken + parms.faultDesc + keytimestamp +
        keytoken + parms.storeCode + keytimestamp +
        keytoken + parms.timeRegion + keytimestamp +
        keytoken + parms.userPhone + keytimestamp +
        keytoken + parms.userName + keytimestamp;
      let keysign: any = md5(ooodata)
      let otherkeydata: any = {
        key: keydata.data.key,
        secret: keydata.data.secret,
        token: keyhead.token,
        timestamp: keyhead.timestamp,
        sign: keysign,
      }



      let res: any = await WebApi.delisubmit(parms, otherkeydata, this.state.token);
      if (res && +res.code === 200) {
        // facebook监测
        fbq('track', 'SubmitApplication');
        twq('event', 'tw-o6z63-obxfj', {
          conversion_id: "SubmitApplication" // use this to pass a unique ID for the conversion event for deduplication (e.g. order id '1a2b3c')
        });

        this.props.clear();

        // 谷歌埋点---下单成功
        gtag('event', 'Reservation_ordersuccess' + Gtinit());

        if (makemoney) {
          this.props.history.push("/reserSuccess?makemoney=1&orderNum=" + res.data.orderNum);
        } else if (ccactivity === 'moneytree') {
          this.props.history.push("/reserSuccess?ccactivity=moneytree&orderNum=" + res.data.orderNum);
        } else {
          this.props.history.push("/reserSuccess?orderNum=" + res.data.orderNum);
        }
      } else {
        Toast.fail(intl.get("error.name5"), 2);
      }
    }
  };

  verifysuccess = () => {
    let status: number = this.state.tjstatus;
    let _this = this;
    setTimeout(() => {
      _this.setState({ tjstatus: 0 })
      if (status === 1) {
        _this.pttj();
      } else if (status === 2) {
        _this.jxtj();
      }
    }, 1200);
  }
  // 获取物流单子
  getVcode=async () => {
    console.log("刷新验证码");
    let res:any=await WebApi.wuliulistVcode({});
    if(res&&+res.code===200){
      let resData:any=res.data||{}
      this.setState({
        vcodeuuid: resData.uuid||"",
        vcodeimg: resData.imageData||"",
      })
    }
  }

  render() {
    const { getFieldProps } = this.props.form;
    return (
      <div
        style={{
          paddingBottom: "0.4rem",
        }}
        className={this.state.isAr ? "subscribe1" : ""}
        onClick={() => {
          if (this.state.pcModelshow) { this.setState({ pcModelshow: false }); }
        }}
      >
        <div className="subscribe">
          {/* <Sunnbirdback /> */}
          {/* 滑动验证码 */}
          {this.state.tjstatus ?
            <Verify success={this.verifysuccess} close={() => { this.setState({ tjstatus: 0 }) }} /> : ''}
          {/* 头部导航 */}
          <Title content={intl.get("title.name3")} show={true} handle={this.onSite} />
          {/* 宣传图片 */}
          <img className="banner" src={this.props.imgUrl || Img1} alt="" />
          {/* 印尼订单模块查询 */}
          {this.props.countryActiveMcc === '510' && (!this.state.appVersion) ?
            <div className="detail_enter"><span onClick={() => {
              // 谷歌埋点---delivery detail 首页按钮点击量
              gtag('event', 'delivery detail- homepage button click h5');
              this.setState({ showEnter: true });
              // 验证码请求
              this.getVcode();
            }}>{intl.get("add3.name34")}</span></div>
            : ""}
          {/* 印尼订单模块查询--弹窗 */}
          {this.state.showEnter ?
            <div className="detail_enter_tip">
              <div className="cover"></div>
              <div className="detail_tip_content">
                <h3>{intl.get("add3.name10")}</h3>
                <div className="input">
                  <input type="text" placeholder={intl.get("add3.name12") + "/" + intl.get("add3.name8")} maxLength={30}
                    value={this.state.detailCode}
                    onChange={(e: any) => { this.setState({ detailCode: e.target.value }) }} />
                </div>
                {/* 验证码部分 */}
                <div className="input">
                  <input type="text" placeholder={"Masukkan kode verifikasi"} maxLength={5}
                    value={this.state.vcode}
                    onChange={(e: any) => { this.setState({ vcode: e.target.value }) }} />
                    <div className="img" onClick={this.getVcode}><img src={this.state.vcodeimg||""} alt="" /></div>
                </div>
                <div className="btns">
                  <div className="btn_l" onClick={() => this.setState({ showEnter: false, detailCode: '' })}>{intl.get("order.name15")}</div>
                  <div className={this.state.detailCode.trim()&&this.state.vcode.trim().length===5?"btn_r":"btn_l"} onClick={this.checkDetail}>{intl.get("order.name14")}</div>
                </div>
              </div>
            </div>
            : ""}
          {/* 寄修超过40公里 */}
          {this.state.deliover40 ?
            <div className="deliover40_tip">
              <div className="cover" onClick={() => { this.setState({ deliover40: false }) }}></div>
              <div className="deliover40_content">
                <h3>{intl.get("add3.name46")}</h3>
                <img src={require("../../assets/qr.png")} alt="" />
                <h4>{intl.get("add3.name47")}</h4>
                <p>{intl.get("add3.name48")}</p>
                <p><a href="tel:6281290090559">{"+62-812-9009-0559"}</a></p>
                <div className="btn" onClick={() => { this.setState({ deliover40: false }) }}>{intl.get("order.name16")}</div>
              </div>
            </div>
            : ""
          }
          {/* 选项模块 */}
          <div className="parts">
            {/* choose model */}
            <div className="part mt24">
              {/* 泰国省份 */}
              {this.props.countryActiveMcc === "520" && this.props.storeState.thpro.provinceThai ?
                <div className="prolat">
                  <span onClick={() => { this.setState({ isthpro: true }) }}>
                    <img src={require('../../assets/prolocation.png')} alt="" />
                    <i>{intl.get("add2.name20") || 'Choose your province'}:</i>
                    <span>{this.props.storeState.thpro.provinceThai}</span>
                  </span>
                </div> : ''}
              {/* 菲律宾省份 */}
              {this.props.countryActiveMcc === "515" && this.props.storeState.thpro.provinceThai ?
                <div className="prolat">
                  <span onClick={() => { this.setState({ isthpro: true }) }}>
                    <img src={require('../../assets/prolocation.png')} alt="" />
                    <i>{intl.get("add2.name20") || 'Choose your province'}:</i>
                    <span>{this.props.storeState.thpro.provinceThai}</span>
                  </span>
                </div> : ''}
              {/* 印尼城市--印度一样 */}
              {this.props.isDeliverySite===1 && this.props.cityname.cityEng && this.props.cityname.cityEng.toLocaleLowerCase() !== 'others' ?
                <div className="prolat">
                  <span onClick={() => { this.props.setcityshow(true) }}>
                    <img src={require('../../assets/prolocation.png')} alt="" />
                    <i>{intl.get("add1.name00") || intl.get("add1.name2")}:</i>
                    <span>{this.props.cityname.cityThai}</span>
                  </span>
                </div> : ''}
              {/* 上门展示 */}
              {this.props.isDeliverySite===2?
                <div className="prolat">
                  <span onClick={() => { this.setState({isOnSite:true}) }}>
                    <img src={require('../../assets/prolocation.png')} alt="" />
                    <i>{intl.get("onSiteService.name6")}</i>
                    <span>{this.props.onSiteCity.serviceLocation||this.props.onSiteCity.serviceLocationEn}</span>
                  </span>
                </div> : ''}
              {/* 选择维修的类型----到店，上门，寄售服务 */}
              {this.props.isDeliveryArea||this.props.onSiteService?
                <div className="deliverypart">
                  <h3>{intl.get("add2.name1")}</h3>
                  <div className="choosesite_mobile">
                    {/* <div className={"choosesite"}> */}
                    <div className={"choosesite"+(this.props.onSiteService&&this.props.isDeliveryArea?" choosesite3":"")}>
                      <div onClick={this.inStore} className={this.props.isDeliverySite===0 ? 'act' : ''}>{intl.get("add2.name2")}</div>
                      {this.props.onSiteService?<div onClick={this.handleonSiteService} className={this.props.isDeliverySite===2 ? 'act' : ''}>{intl.get("onSiteService.name2")}</div>:""}
                      {this.props.isDeliveryArea?<div onClick={this.onSite} className={this.props.isDeliverySite===1 ? 'act' : ''}>{this.props.countryActiveMcc === "404000" ? (intl.get("add2.name31") || "Pick-up and Drop") : intl.get("add2.name3")}</div>:""}
                    </div>
                  </div>
                  <div className="choosesite_pc">
                    <div onClick={this.inStore} className={this.props.isDeliverySite===0 ? 'act' : ''}>
                      {this.props.isDeliverySite===0 ? <img src={require("../../assets/pc/store1.png")} alt="" />
                        : <img src={require("../../assets/pc/store0.png")} alt="" />}
                      {intl.get("add2.name2")}</div>
                      {/* 上门 */}
                    {this.props.onSiteService?<div onClick={this.handleonSiteService} className={this.props.isDeliverySite===2 ? 'act' : ''}>
                      {this.props.isDeliverySite===2 ? <img src={require("../../assets/pc/onsite_active.png")} alt="" />
                        : <img src={require("../../assets/pc/onsite.png")} alt="" />}
                      {intl.get("onSiteService.name2")}</div>:""}
                      {/* 寄修 */}
                      {this.props.isDeliveryArea?
                    <div onClick={this.onSite} className={this.props.isDeliverySite===1 ? 'act' : ''}>
                      {this.props.isDeliverySite===1 ?
                        <img src={require("../../assets/pc/car1.png")} alt="" /> :
                        <img src={require("../../assets/pc/car0.png")} alt="" />}
                      {this.props.countryActiveMcc === "404000" ? (intl.get("add2.name31") || "Pick-up and Drop") : intl.get("add2.name3")}</div>
                      :''}
                  </div>
                </div> : ''}

              <h3>{intl.get("error.name7")}</h3>
              <div className="models">
                {/* 选择机型移动端 */}
                <div className="quatext mobileshow" onClick={this.toModel}>
                  {this.props.model.rightCode + "" ? (
                    <span>
                      {
                        (this.props.model.leftName === intl.get('add2.name13') ? "" : this.props.model.leftName) +
                        " " +
                        this.props.model.rightName
                      }
                    </span>
                  ) : (
                    <span className="light">{intl.get("order.name1")}</span>
                  )}
                  <Icon type="right" />
                </div>
                {/* 选择机型pc端 */}
                <div className="pcshow">
                  <div className="quatext " onClick={this.toModelpc}>
                    {this.props.model.rightCode + "" ? (
                      <span>
                        {
                          (this.props.model.leftName === intl.get('add2.name13') ? "" : this.props.model.leftName) +
                          " " +
                          this.props.model.rightName
                        }
                      </span>
                    ) : (
                      <span className="light">{intl.get("order.name1")}</span>
                    )}
                    <Icon className={this.state.pcModelshow ? "r270" : "r90"} type="right" />
                  </div>
                  {this.state.pcModelshow ?
                    <div className="pcmodel" onClick={(e: any) => { e.stopPropagation(); }}>
                      <PCModel handle={() => { this.setState({ pcModelshow: false }) }} />
                    </div>
                    : ""}
                </div>


                {this.state.SSA||this.props.countryActiveMcc==='250'?"":<div className="model-price" onClick={this.toPrice}>
                  <img src={Search} alt="" />
                  <span>{intl.get("order.name11")}</span>
                </div>}
              </div>
            </div>
            {/* Description */}
            <div className="part">
              {/* 寄修业务 */}
              {this.props.isDeliverySite===1 ?
                <div className="deliverypart">
                  <h3>{intl.get("add2.name4")}：</h3>
                  <div className="address tlmobileshow" onClick={this.toFaultType}>
                    <div className="name">
                      {this.props.deliveryFaulttype.length > 0 ? (
                        this.props.deliveryFaulttype[2].title || this.props.deliveryFaulttype[2]
                      ) : (
                        <span>{intl.get("add2.name5")}</span>
                      )}
                      <Icon type="right" />
                    </div>
                  </div>
                  <div className="address timepcshow" onClick={this.showFaultType}>
                    <div className="name">
                      {this.props.deliveryFaulttype.length > 0 ? (
                        this.props.deliveryFaulttype[2].title || this.props.deliveryFaulttype[2]
                      ) : (
                        <span>{intl.get("add2.name5")}</span>
                      )}
                      <Icon type="right" />
                    </div>
                  </div>
                  {this.props.deliveryFaulttype[0] === -1 ? <div className={this.props.problems ? "" : "notext"}>
                    <div>
                      <TextareaItem
                        {...getFieldProps("part1")}
                        value={this.props.problems}
                        onChange={this.handleTextareaChange}
                        placeholder={intl.get("add2.name14")}
                      />
                    </div>
                  </div> : ''}
                </div> :
                (this.state.isgooduser ? (
                  <div className="gooduser">
                    <h3>{intl.get("coupons.name6")}</h3>
                    <div className="choosesite">
                      <div onClick={() => { this.props.setProblems('Free Cleaning'); }} className={this.props.problems === 'Software Upgrade' ? '' : 'act'}>{intl.get("coupons.name7")}</div>
                      <div onClick={() => { this.props.setProblems('Software Upgrade'); }} className={this.props.problems === 'Software Upgrade' ? 'act' : ''}>{intl.get("coupons.name8")}</div>
                    </div>
                  </div>
                ) : <div className={this.props.problems ? "" : "notext"}>
                  <TextareaItem
                    {...getFieldProps("part1")}
                    value={this.props.problems}
                    onChange={this.handleTextareaChange}
                    placeholder={(intl.get("runame7"))||(intl.get("error.name8"))}
                  />
                </div>)}
            </div>
          </div>
        </div>
        <div className="reservation">
          <div className="part">
            {this.props.isDeliverySite===1 && this.props.countryActiveMcc === '510' ? <>
              {/* 寄售业务 */}
              <div className="deliverypart">
                <div className="time">
                  <div className="top">{intl.get("add2.name6")}</div>
                  <div id="picker">
                    <Icon type="right" />
                    <div className="pick">
                      <Picker
                        title={intl.get("add2.name6")}
                        extra={intl.get("add2.name7")}
                        data={this.state.timeList}
                        value={this.props.time}
                        onChange={(v) => {
                          // 谷歌埋点---PV-time
                          gtag('event', 'Reservation_PV-time' + Gtinit());
                          this.props.setTime(v)
                        }}
                        onOk={(v) => this.props.setTime(v)}
                        okText={intl.get("order.name16")}
                        dismissText={intl.get("order.name15")}
                        format={(labels) => {
                          return labels.join("  ");
                        }}
                      >
                        <CustomChildren></CustomChildren>
                      </Picker>
                    </div>
                  </div>
                </div>
              </div>
            </> : <>
              {/* 常规业务 */}
              <div className="store">
                <div className="top tlmobileshow">{intl.get("order.name4")}</div>
                <div className="top timepcshow">{intl.get("runame3")||(intl.get("order.name4").replace(":", ' & ').replace("：", ' & ') + intl.get("order.name5"))}</div>
                <div className="address" onClick={this.toShops}>
                  <div className="name">
                    {this.props.shopMessage.storeCode ? (this.props.shopMessage.storeName
                    ) : (<>
                      <span className="tlmobileshow">{intl.get("order.name3")}</span>
                      <span className="timepcshow">{intl.get("runame4")||(intl.get("order.name3") + " & " + intl.get("order.name5"))}</span></>
                    )}
                    <Icon type="right" />
                  </div>
                  {this.props.shopMessage.storeCode ? (
                    <>
                      <div className="dress tlmobileshow">
                        <img src={Position} alt="" />
                        <span>{this.props.shopMessage.storeAddr}</span>
                      </div>
                      {this.props.shopMessage.storeAddr ? (
                        <div className="dresspc timepcshow">
                          <img src={require("../../assets/pc/icon4.png")} alt="" />
                          <span>{this.props.shopMessage.storeAddr}</span>
                        </div>
                      ) : ''}
                      <div className="dresspc timepcshow">
                        <img src={require("../../assets/pc/icon9.png")} alt="" />
                        <span>{this.props.time[0] + " " + this.props.time[1]}</span>
                      </div>
                    </>
                  ) : (
                    ""
                  )}
                </div>
              </div>
              {this.props.isDeliverySite===1 && (this.props.countryActiveMcc === '520'||this.props.countryActiveMcc === '515' || this.props.countryActiveMcc === '404000') ?
                // 泰国寄售业务时间
                <div className="time tlmobileshow">
                  <div className="top">{intl.get("add2.name6")}</div>
                  <div id="picker">
                    <Icon type="right" />
                    <div className="pick">
                      <Picker
                        title={intl.get("add2.name6")}
                        extra={intl.get("add2.name7")}
                        data={this.state.timeList}
                        value={this.props.time}
                        onChange={(v) => {
                          // 谷歌埋点---PV-time
                          gtag('event', 'Reservation_PV-time' + Gtinit());
                          this.props.setTime(v)
                        }}
                        onOk={(v) => this.props.setTime(v)}
                        okText={intl.get("order.name16")}
                        dismissText={intl.get("order.name15")}
                        format={(labels) => {
                          return labels.join("  ");
                        }}
                      >
                        <CustomChildren></CustomChildren>
                      </Picker>
                    </div>
                  </div>
                </div> :
                // 常规业务时间
                <div className="time pctime">
                  <div className="top">{intl.get("order.name5")}</div>
                  <div id="picker">
                    <Icon type="right" />
                    <div className="pick">
                      {!this.props.shopMessage.storeCode ? (
                        <div
                          className="noTime"
                          onClick={() => {
                            Toast.info(intl.get("error.name4"), 3);
                          }}
                        ></div>
                      ) : (
                        ""
                      )}
                      <Picker
                        title={intl.get("order.name9")}
                        extra={intl.get("order.name7")}
                        data={this.state.timeList}
                        value={this.props.time}
                        onChange={(v) => {
                          // 谷歌埋点---PV-time
                          gtag('event', 'Reservation_PV-time' + Gtinit());
                          this.props.setTime(v)
                        }}
                        onOk={(v) => this.props.setTime(v)}
                        okText={intl.get("order.name16")}
                        dismissText={intl.get("order.name15")}
                        format={(labels) => {
                          return labels.join("  ");
                        }}
                      >
                        <CustomChildren></CustomChildren>
                      </Picker>
                    </div>
                  </div>
                </div>}
            </>}
            {/* 用户信息 */}
            {/* 移动端 */}
            <div className="info tlmobileshow">
              <div className="top">{intl.get("order.name12")}</div>
              <div className="input">
                <input
                  type="text"
                  maxLength={99}
                  value={this.props.infoName}
                  onChange={this.name}
                  placeholder={intl.get("order.name13")}
                />
              </div>
              <div className="input phoneinput">
                {/* 新增号码长度校验 */}
                {this.props.countryActiveMcc && countryList[this.props.countryActiveMcc] ?
                  <span>+{countryList[this.props.countryActiveMcc].areaTel}</span> : ''
                }
                <input
                  value={this.props.infoPhone}
                  type="number"
                  maxLength={99}
                  onChange={this.phone}
                  placeholder={intl.get("order.name10")}
                />
              </div>
               {this.props.isDeliverySite===2?<div className="input">
                  <input
                    type="text"
                    maxLength={300}
                    value={this.props.deliveryAddrees1}
                    onChange={(e: any) => {
                      this.props.setDeliver({ type: 3, data: e.target.value });
                    }}
                    placeholder={intl.get("add2.name9")}
                  />
                </div>:""}
            </div>
            {/* pc端 */}
            <div className="info pcinfo timepcshow">
              <div className="item">
                <div className="top">{intl.get("order.name13") || intl.get("add3.name7")}</div>
                <div className="input">
                  <input
                    type="text"
                    maxLength={99}
                    value={this.props.infoName}
                    onChange={this.name}
                    placeholder={intl.get("lang")==='ru'?'':intl.get("order.name13")}
                  />
                </div>
              </div>
              <div className="item">
                <div className="top">{intl.get("order.name10") || intl.get("add3.name8")}</div>
                <div className="input phoneinput">
                  {/* 新增号码长度校验 */}
                  {this.props.countryActiveMcc && countryList[this.props.countryActiveMcc] ?
                    <span>+{countryList[this.props.countryActiveMcc].areaTel}</span> : ''
                  }
                  <input
                    value={this.props.infoPhone}
                    type="number"
                    maxLength={99}
                    onChange={this.phone}
                    placeholder={intl.get("lang")==='ru'?'':intl.get("order.name10")}
                  />
                </div>
              </div>
            </div>
            {this.props.isDeliverySite===2?
            <div className="info pcinfo timepcshow">
              <div className="item item_homeMaintenanceAddress">
                <div className="top">{intl.get("add2.name9")}</div>
                <div className="input">
                  <input
                    type="text"
                    maxLength={300}
                    value={this.props.deliveryAddrees1}
                    onChange={(e: any) => {
                      this.props.setDeliver({ type: 3, data: e.target.value });
                    }}
                    placeholder={intl.get("add2.name9")}
                  />
                </div>
              </div>
            </div>
            :""}
            {/* 寄售业务 */}
            {this.props.isDeliverySite===1 ?
              <div className="info">
                <div className="deliverypart">
                  {/* 邮寄地址 */}
                  <div className="top">{intl.get("add2.name8")}</div>
                  <div className="input">
                    <input
                      type="text"
                      maxLength={300}
                      value={this.props.deliveryAddrees1}
                      onChange={(e: any) => {
                        this.props.setDeliver({ type: 3, data: e.target.value });
                      }}
                      placeholder={intl.get("add2.name9")}
                    />
                  </div>
                  {/* <div className="input" style={{ display: "none" }}> */}
                  <div className={this.props.countryActiveMcc === "404000" ? 'input' : "input displaynone"}>
                    <input
                      type="text"
                      maxLength={99}
                      value={this.props.deliveryAddcode1}
                      onChange={(e: any) => {
                        this.props.setDeliver({ type: 4, data: e.target.value });
                      }}
                      placeholder={intl.get("add2.name10")}
                    />
                  </div>
                  {this.props.countryActiveMcc === "404000" ? '' :
                    <div className="needAdd2">
                      <i className={this.props.needDeliveryAddrees2 ? "needAdd2_active" : ''} onClick={() => {
                        if (this.props.needDeliveryAddrees2) {
                          this.props.setDeliver({ type: 5, data: false });
                        } else {
                          this.props.setDeliver({ type: 5, data: true });
                        }
                      }}>√</i><span>{intl.get("add2.name11")}</span>
                    </div>}
                </div>
                {this.props.needDeliveryAddrees2 ?
                  <div className="deliverypart">
                    {/* 回寄地址 */}
                    <div className="top">{intl.get("add2.name12")}</div>
                    <div className="input">
                      <input
                        type="text"
                        maxLength={300}
                        value={this.props.deliveryAddrees2}
                        onChange={(e: any) => {
                          this.props.setDeliver({ type: 6, data: e.target.value });
                        }}
                        placeholder={intl.get("add2.name16")}
                      />
                    </div>
                    {/* <div className="input" style={{ display: "none" }}> */}
                    <div className={this.props.countryActiveMcc === "404000" ? 'input' : "input displaynone"}>
                      <input
                        type="text"
                        maxLength={99}
                        value={this.props.deliveryAddcode2}
                        onChange={(e: any) => {
                          this.props.setDeliver({ type: 7, data: e.target.value });
                        }}
                        placeholder={intl.get("add2.name17")}
                      />
                    </div>
                  </div> : ""
                }
              </div> : ""}
            <div className="tip tlmobileshow">
              <span className="icon">!</span>
              <span className="text">{intl.get("order.name8")}</span>
            </div>
          </div>
          {this.props.isDeliverySite===1 ?
            // 寄售业务按钮
            <div
              className={
                this.canDeliveryBtn()
                  ? "submitBtn"
                  : "submitBtn light"
              }
              onClick={this.onDeliveryBtn}
            >
              {intl.get("order.name14")}
            </div> :
            // 非寄售业务按钮
            <div
              className={
                this.canBtn()  
                  ? "submitBtn"
                  : "submitBtn light"
              }
              onClick={this.onBtn}
            >
              {intl.get("order.name14")}
            </div>}
        </div>

        {/* 泰国弹窗 */}
        {this.state.isthpro ?
          <div className="thprolist">
            <div className="cover"></div>
            <div className="thproitems">
              <div>
                <h3>{intl.get("add2.name20") || 'Choose your province'}：</h3>
              </div>
              <ul>
                {this.props.proList.map((v: any, i: number) =>
                  <li key={i} className={v.provinceEng === this.props.storeState.thpro.provinceEng ? "active" : ''} onClick={() => {
                    if (v.provinceEng !== this.props.storeState.thpro.provinceEng) {
                      console.log('变化');
                      this.props.setTime([])
                      this.props.setShop({
                        storeName: "",
                        storeCode: "",
                        storeAddr: "",
                      })
                    }
                    this.props.setThpro(v); this.setState({ isthpro: false });
                  }}>{v.provinceThai}</li>
                )}
              </ul>
              {/* <div className="img"><img onClick={() => { this.setState({ isthpro: false }) }} src={require("../../assets/images/pcclose.png")} alt="" /></div> */}
            </div>
          </div>
          : ""}

        {/* pcfaulttype */}
        {this.state.pcFaultshow ? <>
          <div className="pcfault">
            <div className="cover"></div>
            <div className="falut_content">
              <div className="close" ><img onClick={() => { this.setState({ pcFaultshow: false }) }} src={require("../../assets/images/close.png")} alt="" /></div>
              <div className="faultbody"><PCFault handle={() => { this.setState({ pcFaultshow: false }) }} /></div>
            </div>
          </div>
        </> : ''}

        {/* 上门维修 */}
        {this.state.isOnSite ?
          <div className="thprolist">
            <div className="cover"></div>
            <div className="thproitems">
              <div>
                <h3>{intl.get("onSiteService.name4")}</h3>
              </div>
              <ul>
                {this.props.onSiteList.map((v: any, i: number) =>
                  <li key={i} className={(v.serviceLocationEn === this.props.onSiteCity.serviceLocationEn)||
                    (v.serviceLocation === this.props.onSiteCity.serviceLocation)? "active" : ''} onClick={() => {
                    this.onSiteService(v)
                    this.props.setonSiteCity(v); this.setState({ isOnSite: false });
                  }}>{v.serviceLocation||v.serviceLocationEn}</li>
                )}
                <li className={(this.props.onSiteCity.serviceLocationEn === (intl.get('add2.name13')||'Others'))? "active" : ''} onClick={() => {
                    this.onSiteService({
                      serviceLocation:'',
                      serviceLocationEn:''
                    })
                    this.props.setonSiteCity({
                      serviceLocation:'',
                      serviceLocationEn:intl.get('add2.name13')||'Others'
                    }); this.setState({ isOnSite: false });
                  }}>{intl.get('add2.name13')||'Others'}</li>
              </ul>
            </div>
          </div>
          : ""}
      </div>
    );
  }
}

export default createForm()(Subscribe);
